<mat-toolbar
  fxLayout="row"
  color="primary"
  *ngIf="isAuthenticated"
  [ngClass]="sidenavReference2.mode === 'over' ? 'toolbar-mobile' : 'toolbar'"
>
  <div
    class="logo"
    (click)="goToDashboard()"
    *ngIf="sidenavReference2.mode === 'over'"
  >
    <img src="assets/images/accutrax-logo-white.png" alt="accutrax Logo" />
  </div>

  <button
    mat-icon-button
    *ngIf="sidenavReference2.mode === 'over'"
    (click)="sidenavReference2.toggle()"
  >
    <mat-icon *ngIf="!sidenavReference2.opened">menu</mat-icon>
    <!-- <mat-icon *ngIf="sidenavReference.opened">close</mat-icon> -->
  </button>
  <ng-container *ngFor="let item of menuItems">
    <button
      mat-button
      *ngIf="!item.hasSubMenu; else subMenu"
      class="menu-item"
      [routerLink]="item.route"
      [fxShow]="item.showOnDesktop"
      [fxShow.xs]="item.showOnMobile"
      [fxShow.sm]="item.showOnTablet"
    >
      {{ item.label }}
    </button>
    <ng-template #subMenu>
      <button
        *ngIf="showCalendarButton"
        mat-button
        class="menu-item"
        [matMenuTriggerFor]="calendarMenu"
        [fxShow]="item.showOnDesktop"
        [fxShow.xs]="item.showOnMobile"
        [fxShow.sm]="item.showOnTablet"
      >
        Calendar
      </button>
      <ng-container>
        <mat-menu #calendarMenu="matMenu">
          <button
            *ngIf="
              userRole === 'Sales Manager' ||
              userRole === 'Admin' ||
              userRole === 'Super Admin' ||
              userRole === 'Office Staff' ||
              userRole === 'Customer Care Liaison' ||
              userRole === 'Customer Service Admin' ||
              userRole === 'Service Backup' ||
              userRole === 'Inside Sales' ||
              userRole === 'Inside Sales Manager' ||
              userRole === 'ACR' ||
              userRole === 'Production Scheduling' ||
              userRole === 'Service Scheduling' ||
              userRole === 'Service Manager' ||
              userRole === 'Finance'
            "
            mat-menu-item
            [routerLink]="[item.route, 'sales-monthly']"
          >
            Sales - Monthly
          </button>
          <mat-divider></mat-divider>
          <button
            *ngIf="userRole === 'Estimator'"
            mat-menu-item
            [routerLink]="[item.route, 'sales-personal']"
          >
            Sales - My Calendar
          </button>
          <mat-divider></mat-divider>
          <button
            *ngIf="
              userRole === 'Sales Manager' ||
              userRole === 'Superintendent' ||
              userRole === 'Production Manager' ||
              userRole === 'Production Scheduling' ||
              userRole === 'Admin' ||
              userRole === 'Super Admin' ||
              userRole === 'Office Staff' ||
              userRole === 'Customer Care Liaison' ||
              userRole === 'Customer Service Admin' ||
              userRole === 'Service Backup' ||
              userRole === 'Inside Sales' ||
              userRole === 'Inside Sales Manager' ||
              userRole === 'ACR' ||
              userRole === 'Warehouse' ||
              userRole === 'Service Scheduling' ||
              userRole === 'Service Manager' ||
              userRole === 'Finance'
            "
            mat-menu-item
            [routerLink]="[item.route, 'prod-weekly']"
          >
            Production - Weekly
          </button>
          <mat-divider></mat-divider>
          <button
            *ngIf="
              userRole === 'Sales Manager' ||
              userRole === 'Superintendent' ||
              userRole === 'Production Manager' ||
              userRole === 'Production Scheduling' ||
              userRole === 'Admin' ||
              userRole === 'Super Admin' ||
              userRole === 'Office Staff' ||
              userRole === 'Customer Care Liaison' ||
              userRole === 'Customer Service Admin' ||
              userRole === 'Service Backup' ||
              userRole === 'Inside Sales' ||
              userRole === 'Inside Sales Manager' ||
              userRole === 'ACR' ||
              userRole === 'Warehouse' ||
              userRole === 'Service Scheduling' ||
              userRole === 'Service Manager' ||
              userRole === 'Finance'
            "
            mat-menu-item
            [routerLink]="[item.route, 'prod-monthly']"
          >
            Production - Monthly
          </button>
          <mat-divider></mat-divider>
          <button
            *ngIf="userRole === 'Foreman'"
            mat-menu-item
            [routerLink]="[item.route, 'prod-personal']"
          >
            Production - My Calendar
          </button>
          <mat-divider></mat-divider>
          <button
            *ngIf="
              userRole === 'Sales Manager' ||
              userRole === 'Service Manager' ||
              userRole === 'Service Scheduler' ||
              userRole === 'Admin' ||
              userRole === 'Super Admin' ||
              userRole === 'Office Staff' ||
              userRole === 'Customer Care Liaison' ||
              userRole === 'Customer Service Admin' ||
              userRole === 'Service Backup' ||
              userRole === 'Inside Sales' ||
              userRole === 'Inside Sales Manager' ||
              userRole === 'ACR' ||
              userRole === 'Service Scheduling' ||
              userRole === 'Finance'
            "
            mat-menu-item
            [routerLink]="[item.route, 'service-weekly']"
          >
            Service - Weekly
          </button>
          <mat-divider></mat-divider>
          <button
            *ngIf="
              userRole === 'Sales Manager' ||
              userRole === 'Service Manager' ||
              userRole === 'Service Scheduler' ||
              userRole === 'Admin' ||
              userRole === 'Super Admin' ||
              userRole === 'Office Staff' ||
              userRole === 'Customer Care Liaison' ||
              userRole === 'Customer Service Admin' ||
              userRole === 'Service Backup' ||
              userRole === 'Inside Sales' ||
              userRole === 'Inside Sales Manager' ||
              userRole === 'ACR' ||
              userRole === 'Service Scheduling' ||
              userRole === 'Finance'
            "
            mat-menu-item
            [routerLink]="[item.route, 'service-monthly']"
          >
            Service - Monthly
          </button>
          <mat-divider></mat-divider>
          <button
            *ngIf="userRole === 'Service Tech'"
            mat-menu-item
            [routerLink]="[item.route, 'service-personal']"
          >
            Service - My Calendar
          </button>
          <mat-divider></mat-divider>
        </mat-menu>
      </ng-container>
    </ng-template>
  </ng-container>

  <button
    class="mailing-requests-button"
    *ngIf="
      currentUserRole === 'Office Staff' ||
      currentUserRole === 'Admin' ||
      currentUserRole === 'Super Admin' ||
      currentUserRole === 'ACR'
    "
    mat-button
    [fxShow.xs]="false"
    [fxShow.sm]="false"
    [routerLink]="['counts/list/mailingRequests']"
  >
    Mailing Requests - {{ mailingRequestsCount }}
  </button>

  <span class="spacer"></span>

  <h1 class="test-site-warning" color="warn" *ngIf="isNonProduction">
    Accutrax Test Site
  </h1>

  <button
    *ngIf="userRole === 'Estimator' && statementsMissing"
    [fxShow.xs]="false"
    [fxShow.sm]="false"
    (click)="triggerReloadStatements()"
    class="missing-statements-button"
    mat-raised-button
    color="warn"
  >
    Missing Statements
  </button>

  <div
    class="sync-wrapper"
    *ngIf="
      getCurrentOfflineStatus() &&
      (currentPath.includes('dashboard') ||
        currentPath.includes('calendar') ||
        currentPath.includes('customers'))
    "
    [fxShow.xs]="false"
    [fxShow.sm]="false"
  >
    <button mat-raised-button color="accent" (click)="openSyncDialog()">
      Sync Data
      <mat-icon>cloud_upload</mat-icon>
    </button>
  </div>

  <!-- Button for Admin menu -->
  <button
    [ngStyle]="{ 'align-self': 'center', 'margin-left': '2rem' }"
    mat-icon-button
    [matMenuTriggerFor]="dropMenu"
    class="menu-item"
  >
    <mat-icon>more_vert</mat-icon>
  </button>

  <!-- Hamburger menu -->
  <mat-menu #dropMenu="matMenu">
    <div class="user-info">
      <h2>User Info</h2>
      <span
        *ngIf="
          userRole !== 'Estimator' &&
          userRole !== 'Foreman' &&
          userRole !== 'Service Tech'
        "
        >Company Code: {{ currentUserCompanyCode }}</span
      >
      <span>Email: {{ currentUserEmail }}</span>
      <span>Role: {{ currentUserRole }}</span>
    </div>
    <div *ngIf="userRole === 'Admin' || userRole === 'Super Admin'">
      <mat-divider></mat-divider>
      <button mat-menu-item [routerLink]="'admin/users'">Admin</button>
      <mat-divider></mat-divider>
    </div>
    <div
      *ngIf="
        userRole !== 'Estimator' &&
        userRole !== 'Foreman' &&
        userRole !== 'Service Tech'
      "
    >
      <mat-divider></mat-divider>
      <button mat-menu-item [matMenuTriggerFor]="companySelectMenu">
        Company Select
      </button>
      <mat-divider></mat-divider>
    </div>
    <div *ngIf="userRole === 'Estimator' && connectionStatus">
      <mat-divider></mat-divider>
      <button mat-menu-item [routerLink]="'sentToInsideSales'">
        Sent to Inside Sales
      </button>
      <mat-divider></mat-divider>
    </div>
    <div *ngIf="connectionStatus">
      <mat-divider></mat-divider>
      <button mat-menu-item [routerLink]="'reports'">Reports</button>
      <mat-divider></mat-divider>
    </div>
    <div
      *ngIf="
        userRole === 'Admin' ||
        userRole === 'Super Admin' ||
        userRole === 'Inside Sales' ||
        userRole === 'Inside Sales Manager'
      "
    >
      <mat-divider></mat-divider>
      <button mat-menu-item [routerLink]="'followUps'">Follow Ups</button>
      <mat-divider></mat-divider>
    </div>
    <div *ngIf="userRole === 'Foreman' || userRole === 'Service Tech'">
      <mat-divider></mat-divider>
      <button mat-menu-item [routerLink]="'vehicle-documentation'">
        View Vehicle Documentation
      </button>
      <mat-divider></mat-divider>
    </div>
    <div>
      <mat-divider></mat-divider>
      <button mat-menu-item (click)="openBugReportWindow()">
        Request Support
      </button>
      <mat-divider></mat-divider>
    </div>
    <div>
      <mat-divider></mat-divider>
      <button mat-menu-item (click)="logout()">Logout</button>
      <mat-divider></mat-divider>
    </div>
  </mat-menu>

  <!-- Company Select nested menu -->
  <mat-menu #companySelectMenu="matMenu">
    <div class="current-company-header" *ngIf="currentUserCompanyCode">
      <small>Current: {{ currentUserCompanyCode }}</small>
    </div>
    <mat-divider *ngIf="currentUserCompanyCode"></mat-divider>
    <button
      mat-menu-item
      *ngFor="let companyCode of companyCodes"
      (click)="onCompanyCodeSelected(companyCode)"
      [disabled]="companyCode === currentUserCompanyCode"
      [ngClass]="{ 'current-company': companyCode === currentUserCompanyCode }"
    >
      {{ companyCode }}
      <mat-icon
        *ngIf="companyCode === currentUserCompanyCode"
        class="current-indicator"
        >check_circle</mat-icon
      >
    </button>
  </mat-menu>
</mat-toolbar>
